/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum RiskByDto {
    TARGO = 'TARGO',
    HORNBACH = 'HORNBACH',
    STANDARD = 'STANDARD',
    RISK = 'RISK',
}
